const USE_TOGGLE = false;

export function useSyncToggle() {
    return USE_TOGGLE;
}
